function encodePath(relativePath) {
    return relativePath
        .split("/")
        .filter(Boolean)
        .map((segment) => encodeURIComponent(segment))
        .join("/");
}
function trimTrailingSlashes(value) {
    return value.replace(/\/+$/, "");
}
let tileCdnBaseUrl = null;
let explicitlyConfigured = false;
let warnedMissingBaseUrl = false;
export function configureTileCdnBaseUrl(url) {
    tileCdnBaseUrl = trimTrailingSlashes(url.trim());
    explicitlyConfigured = true;
    warnedMissingBaseUrl = false;
}
/**
 * Test-only hook to reset module state between tests so warning behavior and
 * configuration are deterministic.
 */
export function __resetTileCdnBaseUrlForTesting() {
    tileCdnBaseUrl = null;
    explicitlyConfigured = false;
    warnedMissingBaseUrl = false;
}
function isBrowserEnvironment() {
    return typeof window !== "undefined" && typeof document !== "undefined";
}
function readBaseUrlFromEnv() {
    if (typeof process === "undefined" || !process.env) {
        return null;
    }
    const value = process.env.SUPABASE_TILE_CDN_BASE_URL?.trim() ||
        process.env.NEXT_PUBLIC_SUPABASE_TILE_CDN_BASE_URL?.trim() ||
        null;
    return value || null;
}
function getTileCdnBaseUrl() {
    if (tileCdnBaseUrl) {
        return tileCdnBaseUrl;
    }
    const envValue = readBaseUrlFromEnv();
    if (envValue) {
        tileCdnBaseUrl = trimTrailingSlashes(envValue);
        return tileCdnBaseUrl;
    }
    if (!explicitlyConfigured && !warnedMissingBaseUrl && isBrowserEnvironment()) {
        warnedMissingBaseUrl = true;
        // Surface the footgun: anything calling resolveTileAssetUrl at module-init
        // time (before configureTileCdnBaseUrl runs) will produce broken URLs that
        // would otherwise 404 silently.
        console.warn("[tileAssetUrls] resolveTileAssetUrl was called before configureTileCdnBaseUrl(). " +
            "This usually means a module-level `const url = resolveTileAssetUrl(...)` ran " +
            "before app bootstrap. Move the call inside a component (e.g. via useMemo) or " +
            "ensure configureTileCdnBaseUrl runs first.");
    }
    return "";
}
export function resolveTileAssetUrl(relativePath) {
    const normalized = relativePath.replace(/^\/+/, "");
    return `${getTileCdnBaseUrl()}/${encodePath(normalized)}`;
}
